import React from "react";
import { Button } from "react-bootstrap";

export default function ShowModalButton({ handler, variant, icon, className, title }) {
  return (
    <div className="float-right">
      <Button onClick={handler} variant={variant} size="md" className={className} style={{ padding: 0 }} title={title}>
        <i className={icon} />
      </Button>
    </div>
  );
}
